'use client';

import React from 'react';

interface EditorShortcutsProps {
  onInsertArrow: () => void;
  onInsertBulletPoint: () => void;
}

/**
 * [共通]編集ショートカットボタン
 * @param param0
 * @returns
 */
const EditorShortcuts: React.FC<EditorShortcutsProps> = ({ onInsertArrow, onInsertBulletPoint }) => {
  return (
    <div>
      <button
        type="button"
        className="me-1 text-gray-500 bg-white dark:text-white hover:bg-gray-200 p-1 border border-gray-300 rounded"
        onClick={onInsertArrow}>
        <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 10">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth="1"
            d="M1 5h12m0 0L9 1m4 4L9 9"
          />
        </svg>
      </button>
      <button
        type="button"
        className=" text-gray-500 bg-white dark:text-white hover:bg-gray-200 p-1 border border-gray-300 rounded"
        onClick={onInsertBulletPoint}>
        <svg className="w-4 h-4" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 17 10">
          <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeWidth="2"
            d="M6 1h10M6 5h10M6 9h10M1.49 1h.01m-.01 4h.01m-.01 4h.01"
          />
        </svg>
      </button>
    </div>
  );
};

export default EditorShortcuts;
